const spacing = {
  lg: 70,
  md: 60,
}

export default spacing
